import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import { Building, Calendar, Printer, Download, RefreshCw } from "lucide-react";

import axios from "axios";
// import PDCOpenPopup from "./PDCOpenPopup";
// import PDCReportPrint from "./PDCReportPrint";

import PDCReportPrint from "../../components/PDCDirectory/PDCReportPrint";

const QuotationReport = () => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const roles = [
    { id: "value-1", label: "Open Orders", mode: "SALESORDER_OPEN" },
    { id: "value-2", label: "Close Orders", mode: "SALESORDER_CLOSE" },
    { id: "value-3", label: "All Orders", mode: "SALESORDER_ALL" },
    {
      id: "value-4",
      label: "Open Order (itemwise)",
      mode: "SALESORDER_OPEN_COST",
    },
    {
      id: "value-5",
      label: "Closed Order (itemwise)",
      mode: "SALESORDER_COST_CLOSE",
    },
    { id: "value-6", label: "Itemwise-ALL", mode: "SALESORDER_ALL_COST" },
  ];

  const newDate = new Date();
  const today = newDate.toISOString().split("T")[0];
  const [selectedToggle, setSelectedToggle] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [amounts, setAmounts] = useState([]);
  const [transferDate, setTransferDate] = useState(null);
  const [openPDC, setOpenPDC] = useState(false);
  const [selected, setSelected] = useState("value-1");
  const [selectedMod, setSelectedMod] = useState("PDC_R");
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState(today);
  const [salesmanList, setSalesmanList] = useState([]);
  const [banks, setBanks] = useState([]);
  const [bankName, setBankName] = useState("");
  const [includeChecked, setIncludeChecked] = useState(false);
  const [isPDCReportPrint, setIsPDCReportPrint] = useState(false);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [salesPersonList, setSalesPersonList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [soList, setSOList] = useState([]);
  const [ty, setTy] = useState("SALESORDER_OPEN");
  const [soType, setSoType] = useState("-");
  const [soStatus, setSoStatus] = useState("-");
  const [soDept, setSoDept] = useState("-");
  const [soSalesperson, setSoSalesperson] = useState("-");
  const [loadingSO, setLoadingSO] = useState(false);
  useEffect(() => {
    callSalesPersonListAPI();
    fetchDepartments();

    fetchCompanyInfo();
    fetchSOList();
  }, []);

  useEffect(() => {
    fetchSOList();
  }, [ty]);

  const callSalesPersonListAPI = () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const currentDepartmentFromLocalStorage = localStorage.getItem(
      "currentSelectedDepartment",
    );
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setSalesPersonList(res.data);
      })
      .catch((err) => {});
  };

  const fetchDepartments = async () => {
    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

      const apiURL = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/DEPTLIST/-/-`;
      const response = await axios.get(apiURL);
      const data = response.data;
      console.log("Dept List:", data);
      setDepartmentList(data);
    } catch (error) {
      console.error("Error while fetching Dept list!", error);
    }
  };

  const fetchCompanyInfo = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/COMPANYINFO/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      const companyInfoData = data[0];
      console.log("companyInfoData :", companyInfoData);
      setStartDate(dayjs(companyInfoData.fystart).format("YYYY-MM-DD"));

      // fetchPDCReportList(
      //   "PDC_R",
      //   dayjs(companyInfoData.fystart).format("YYYY-MM-DD"),
      //   dayjs(endDate).format("YYYY-MM-DD")
      // );
      // setToDate(dayjs(companyInfoData.ftend).format("YYYY-MM-DD"))
    } catch (err) {
      console.error("Error while fetching companny Info", err);
    }
  };

  const fetchSOList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMSalesOrderAnalysis/${company_code_from_local_storage}/${ty}/-/-/-/${startDate}/${endDate}/-/-/-/-/-/-/-/-/-/-/-/-`;

    try {
      setLoadingSO(true);
      const res = await axios.get(apiUrl);
      setSOList(res.data || []);
    } catch (error) {
      console.error("Error fetching SO list:", error);
    } finally {
      setLoadingSO(false);
    }
  };

  const handleExport = () => {
    // Define columns with field (data key) and headerName (CSV header)
    const columns = [
      { field: "SONO", headerName: "SO No" },
      { field: "DATE", headerName: "Date" },
      { field: "CUSTOMER", headerName: "Customer" },
      { field: "Otype", headerName: "Type" },
      { field: "AMOUNT", headerName: "Amount" },
      { field: "RECEIVED AMT", headerName: "Received Amount" },
      { field: "BALANCE_AMT", headerName: "Balance Amount" },
      { field: "deptno", headerName: "Department" },
      { field: "SALESMAN", headerName: "Salesman" },
      { field: "REFERENCE", headerName: "Reference" },
      { field: "STATUS", headerName: "Status" },
      { field: "comments", headerName: "Comments" },
    ];

    exportToCSV(columns, soList, "Sales_Order_Reports");
  };

  const exportToCSV = (columns, exportData, exportFileName = "export") => {
    if (!columns || !exportData || exportData.length === 0) return;

    // Create header row
    const headerRow = columns.map((col) => col.headerName);

    // Create data rows
    const dataRows = exportData.map((row) =>
      columns.map((col) => {
        let value = row[col.field] ?? "";

        // Special formatting for date
        if (col.field === "CHQDATE" && value) {
          value = dayjs(value).format("DD/MM/YYYY");
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      }),
    );

    // Combine header + data
    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${exportFileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="">
      <div className="my-4 mx-6">
        <h2 className="text-xl text-gray-800 mb-4">Sales Order Reports</h2>
      </div>
      <div className="flex justify-center items-start">
        <div className="w-[26vw] h-[77vh] bg-gradient-to-br from-slate-50 via-white to-slate-50 shadow border-r border-slate-200 p-3 flex flex-col">
          <div className="flex-1 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-slate-300">
            {/* Role Selection - Custom Radio */}
            <div className="">
              <div className="bg-gray-100 py-1 px-1 rounded-md space-y-1 ">
                {roles.map((role) => (
                  <label
                    key={role.id}
                    className={`
        relative flex items-center gap-4 px-4 h-12 rounded-xl cursor-pointer
        border-2 transition-all duration-300 ease-out
        ${
          selected === role.id
            ? "bg-gradient-to-r from-blue-500 to-blue-600 border-blue-500 shadow scale-[1.01]"
            : "bg-white border-slate-200 hover:border-slate-300 hover:shadow hover:scale-[0.99]"
        }
      `}
                  >
                    <input
                      type="radio"
                      name="value-radio"
                      value={role.id}
                      checked={selected === role.id}
                      onChange={() => {
                        setTy(role.mode);
                        setSelected(role.id);
                        setSelectedMod(role.id);
                        // fetchPDCReportList(role.mode, startDate, endDate); // <-- pass the mode to your fetch function
                      }}
                      className="sr-only"
                    />

                    {/* Custom Radio Circle */}
                    <div
                      className={`
          w-5 h-5 rounded-full flex items-center justify-center transition-all duration-200
          ${selected === role.id ? "bg-white" : "bg-slate-300"}
          ${selected === role.id ? "ring-4 ring-blue-400 ring-opacity-30" : ""}
        `}
                    >
                      <div
                        className={`
            w-2 h-2 bg-blue-600 rounded-full transition-transform duration-200
            ${selected === role.id ? "scale-100" : "scale-0"}
          `}
                      />
                    </div>

                    <p
                      className={`text-sm transition-colors ${
                        selected === role.id ? "text-white" : "text-slate-700"
                      }`}
                    >
                      {role.label}
                    </p>

                    {/* Pulse on select */}
                    {selected === role.id && (
                      <div className="absolute inset-0 rounded-xl bg-blue-400 opacity-0" />
                    )}
                  </label>
                ))}
              </div>
              <div className="flex justify-center gap-2 my-4">
                <div className="flex items-center  w-full">
                  <label className="text-xs font-semibold mr-2">
                    With Cost
                  </label>

                  <input
                    type="checkbox"
                    className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                    name="includeWC"
                    // checked={includeWCChecked}
                    // onChange={handleIncludeWCChange}
                  />
                </div>
                <div className="flex items-center  w-full">
                  <label className="text-[0.6rem] font-semibold mr-2">
                    Enable Filter Dropdown
                  </label>

                  <input
                    type="checkbox"
                    className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                    name="includeWC"
                    // checked={includeWCChecked}
                    // onChange={handleIncludeWCChange}
                  />
                </div>
              </div>

              <div className="flex justify-center items-center gap-1 ">
                {/* <div className="">
                            <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                              <ArrowUpRight className="w-4 h-4 mr-2 text-gray-600" />
                              Bank
                            </label>
                            <input
                              value={crAccount}
                              onChange={(e) => setCrAccount(e.target.value)}
                              placeholder="Enter Cr A/C..."
                              className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                                 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 
                                 placeholder-gray-400 transition-all duration-200"
                            />
                          </div> */}

                <div className=" w-full my-2">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                    From Date
                  </label>
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                                 focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                                 transition-all duration-200"
                  />
                </div>

                <div className="w-full">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                    To Date
                  </label>
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                                 focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                                 transition-all duration-200"
                  />
                </div>
              </div>

              <div className="flex justify-left items-center gap-1 my-4">
                <div className="flex-1">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Building className="w-4 h-4 mr-2 text-gray-600" />
                    Type
                  </label>
                  <select
                    value={soType}
                    onChange={(e) => setSoType(e.target.value)}
                    className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                                 placeholder-gray-400 transition-all duration-200"
                  >
                    <option value="">Select Type...</option>
                    <option value="CASH">Cash</option>
                    <option value="CREDIT">Credit</option>
                  </select>
                </div>
                <div className="flex-1">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Building className="w-4 h-4 mr-2 text-gray-600" />
                    Status
                  </label>
                  <select
                    value={soStatus}
                    onChange={(e) => setSoStatus(e.target.value)}
                    className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                                 placeholder-gray-400 transition-all duration-200"
                  >
                    <option value="">Select Status...</option>
                    <option value="CONFIRM">Confirm</option>
                    <option value="DRAFT">Draft</option>
                    <option value="CANCEL">Cancel</option>
                  </select>
                </div>
              </div>
              <div className="flex justify-left items-center gap-1 my-4">
                <div className="flex-1">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Building className="w-4 h-4 mr-2 text-gray-600" />
                    Salesperson
                  </label>
                  <select
                    value={soSalesperson}
                    onChange={(e) => setSoSalesperson(e.target.value)}
                    className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                                 placeholder-gray-400 transition-all duration-200"
                  >
                    <option value="">Select Salesperson...</option>
                    {salesPersonList.map((sperson, index) => (
                      <option key={index} value={sperson.EMP_ID}>
                        {sperson.NAME}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex-1">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Building className="w-4 h-4 mr-2 text-gray-600" />
                    Department
                  </label>
                  <select
                    value={soDept}
                    onChange={(e) => setSoDept(e.target.value)}
                    className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                                 placeholder-gray-400 transition-all duration-200"
                  >
                    <option value="">Select Department...</option>
                    {departmentList.map((dept, index) => (
                      <option key={index} value={dept.deptno}>
                        {dept.deptnodesc}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="flex gap-3 py-2">
              <button
                onClick={fetchSOList}
                className="flex-1 flex items-center justify-center gap-2 
                                   bg-teal-500 text-white 
                                   font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
                                   transform hover:scale-[1.02] active:scale-100 
                                   transition-all duration-200 text-sm"
              >
                <RefreshCw className="w-4 h-4" />
                Apply
              </button>

              <button
                onClick={handleExport}
                className="flex-1 flex items-center justify-center gap-2 
                                   bg-cyan-600 text-white 
                                   font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
                                   transform hover:scale-[1.02] active:scale-100 
                                   transition-all duration-200 text-sm"
              >
                <Download className="w-4 h-4" />
                Export
              </button>
            </div>
          </div>
        </div>
        <div className="w-full h-[77vh] overflow-auto shadow">
          <table className="relative text-xs border-collapse w-full">
            <thead>
              <tr>
                <th className="bg-gray-100  font-normal sticky top-0 border px-2 py-1">
                  SO No
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Date
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Customer
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Type
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Amount
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Received
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Balance
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Dept
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Salesman
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Reference
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Status
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Comments
                </th>
              </tr>
            </thead>

            <tbody>
              {loadingSO ? (
                <tr>
                  <td colSpan={8} className="py-6 text-center">
                    <div className="flex items-center justify-center gap-2 text-gray-500">
                      <svg
                        className="animate-spin h-5 w-5 text-indigo-500"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                          fill="none"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        />
                      </svg>
                      Loading Sales Orders...
                    </div>
                  </td>
                </tr>
              ) : soList?.length > 0 ? (
                soList.map((acc, index) => (
                  <tr key={index} className="text-xs">
                    <td className="border px-2 py-1 text-center">
                      {acc?.SONO ?? "-"}
                    </td>

                    <td className="border px-2 py-1 text-center">
                      {acc?.DATE ? dayjs(acc.DATE).format("DD/MM/YYYY") : "-"}
                    </td>

                    <td className="border px-2 py-1 text-left">
                      {acc?.CUSTOMER ?? "-"}
                    </td>

                    <td className="border px-2 py-1 text-center">
                      {acc?.Otype ?? "-"}
                    </td>

                    <td className="border px-2 py-1 text-right">
                      {acc?.AMOUNT ?? "-"}
                    </td>

                    <td className="border px-2 py-1 text-right">
                      {acc?.["RECEIVED AMT"] ?? "-"}
                    </td>

                    <td className="border px-2 py-1 text-right">
                      {acc?.BALANCE_AMT ?? "-"}
                    </td>

                    <td className="border px-2 py-1 text-center">
                      {acc?.deptno ?? "-"}
                    </td>

                    <td className="border px-2 py-1 text-center">
                      {acc?.SALESMAN ?? "-"}
                    </td>

                    <td className="border px-2 py-1 text-center">
                      {acc?.REFERENCE ?? "-"}
                    </td>

                    <td className="border px-2 py-1 text-center">
                      {acc?.STATUS || "-"}
                    </td>

                    <td className="border px-2 py-1 text-left">
                      {acc?.comments || "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={12} className="text-center py-4 text-gray-500">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {isPDCReportPrint && (
          <div className="m-6">
            <PDCReportPrint
              pdcReportPrintDataFromAPI={accounts}
              setIsPDCReportPrint={setIsPDCReportPrint}
              isPDCReportPrint={isPDCReportPrint}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default QuotationReport;
